import { useState, useEffect } from 'react';
import { client } from '../lib/sanity';

export const useFounderSection = () => {
    const [founderData, setFounderData] = useState({
        title: '',
        description: [],
        image: null,
        loading: true,
        error: null
    });

    useEffect(() => {
        const fetchFounderData = async () => {
            try {
                const query = `*[_type == "aboutUsFounderSection"][0] {
                    title,
                    description,
                    image
                }`;

                const data = await client.fetch(query);

                setFounderData({
                    title: data?.title || '',
                    description: data?.description || [],
                    image: data?.image || null,
                    loading: false,
                    error: null
                });
            } catch (error) {
                setFounderData(prev => ({
                    ...prev,
                    loading: false,
                    error: error.message
                }));
            }
        };

        fetchFounderData();
    }, []);

    return founderData;
};

export const useAboutSection = () => {
    const [aboutData, setAboutData] = useState({
        title: '',
        description: [],
        leftColumn: [],
        rightColumn: [],
        loading: true,
        error: null
    });

    useEffect(() => {
        const fetchAboutData = async () => {
            try {
                const query = `*[_type == "aboutUsAboutSection"][0] {
                    title,
                    description
                }`;

                const data = await client.fetch(query);

                // Split the description into two parts
                const description = data?.description || [];
                const midPoint = Math.ceil(description.length / 2);
                const leftColumn = description.slice(0, midPoint);
                const rightColumn = description.slice(midPoint);

                setAboutData({
                    title: data?.title || '',
                    description: description,
                    leftColumn,
                    rightColumn,
                    loading: false,
                    error: null
                });
            } catch (error) {
                setAboutData(prev => ({
                    ...prev,
                    loading: false,
                    error: error.message
                }));
            }
        };

        fetchAboutData();
    }, []);

    return aboutData;
};

export const useTeamSection = () => {
    const [teamData, setTeamData] = useState({
        title: '',
        description: '',
        teamMembers: [],
        loading: true,
        error: null
    });

    useEffect(() => {
        const fetchTeamData = async () => {
            try {
                const query = `*[_type == "aboutUsTeamSection"][0] {
                    title,
                    description,
                    teamMembers[] {
                        name,
                        position,
                        "imageUrl": image.asset->url
                    }
                }`;

                const data = await client.fetch(query);

                setTeamData({
                    title: data?.title || '',
                    description: data?.description || '',
                    teamMembers: data?.teamMembers || [],
                    loading: false,
                    error: null
                });
            } catch (error) {
                setTeamData(prev => ({
                    ...prev,
                    loading: false,
                    error: error.message
                }));
            }
        };

        fetchTeamData();
    }, []);

    return teamData;
};

export const useWhatWeDoSection = () => {
    const [data, setData] = useState({
        title: '',
        subtitle: '',
        description: '',
        points: [],
        loading: true,
        error: null
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const query = `*[_type == "aboutUsWhatWeDoSectionID"][0] {
                    title,
                    subtitle,
                    description,
                    points[] {
                        title,
                        description,
                        icon,
                        count
                    }
                }`;

                const result = await client.fetch(query);
                setData({
                    title: result?.title || '',
                    subtitle: result?.subtitle || '',
                    description: result?.description || '',
                    points: result?.points || [],
                    loading: false,
                    error: null
                });
            } catch (err) {
                setData(prev => ({
                    ...prev,
                    loading: false,
                    error: err.message
                }));
            }
        };

        fetchData();
    }, []);

    return {
        title: data.title,
        subtitle: data.subtitle,
        description: data.description,
        items: data.points,
        loading: data.loading,
        error: data.error,
    };
}; 